import React, { useState, useEffect } from "react";
import loadable from "@loadable/component";
import { Brand } from "types/common";

const GlobalThemeComponent =
  process.env.NODE_ENV === "production"
    ? null
    : loadable(
        () =>
          import("@tvg/fuse-design/themes").then((m) => ({
            default: m.GlobalThemeComponent,
          })),
        { ssr: false },
      );

const FuseBrandMap = {
  [Brand.Very]: Brand.Very,
  [Brand.VeryIE]: Brand.Very,
  [Brand.Littlewoods]: Brand.Littlewoods,
  default: "default",
} as const;

export default function GlobalTheme({ brand = "default" }: { brand?: keyof typeof FuseBrandMap }) {
  const [isClient, setIsClient] = useState(false);

  // Ensure rendering only happens after hydration
  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient || !GlobalThemeComponent || process.env.NODE_ENV === "production") return null;

  return <GlobalThemeComponent brand={FuseBrandMap[brand]} />;
}
